<template>
  <div
    class="page--employee"
    :style="`min-height: ${height}px`"
  >
    <Header :status="currentStatus" />

    <Form
      :submit="submitForm"
      :status="currentStatus"
      @setCurrentStatus="setCurrentStatus"
    />

    <Footer :status="currentStatus" @submit="handleSubmit" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Header from 'components/employeeMassCreditPolicy/Header'
import Form from 'components/employeeMassCreditPolicy/Form'
import Footer from 'components/employeeMassCreditPolicy/Footer'

export default {
  name: 'EmployeeMassCreditPolicy',
  components: {
    Header,
    Form,
    Footer
  },
  computed: {
    routeParams () {
      return this.$route.params
    },

    height () {
      return document.body.offsetHeight
    }
  },
  data () {
    return {
      namespace: 'Views.EmployeeMassCreditPolicyPage',
      submitForm: false,
      currentStatus: null
    }
  },
  methods: {
    ...mapActions({
      errorAlert: 'snackbarAlert/error'
    }),

    handleSubmit () {
      this.submitForm = !this.submitForm
    },

    setCurrentStatus (val) {
      if (val) this.currentStatus = val
    },

    setChatPosition (bottom = null, right = null) {
      const chat = document.querySelector('#oloswcdl-root .oloswebchat-main .cta-button')
      if (chat) {
        chat.style.bottom = bottom
        chat.style.right = right
      }
    }
  },
  mounted () {
    this.setChatPosition('75px', '10px')
  },
  beforeDestroy () {
    this.setChatPosition()
  }
}
</script>
